export const TYPE = 'shoppingCartCarousel';

/**
 * Inserts a shopping cart section into the article body if the article is shoppable.
 *
 * @param {object} params - The parameters for insertion.
 * @param {boolean} params.isShoppable - Whether the article is shoppable.
 * @param {import("lib/graphqlTypeDefs.mjs").Article} params.article - The article data.
 * @param {string} params.vertical - The vertical/category of the article.
 * @returns {Function} A function that takes the article body array and returns a new array with the shopping cart inserted.
 */
export function insertShoppingCart({
  isShoppable,
  article,
  vertical,
}) {
  if (!isShoppable) {
    return (body) => body;
  }

  return (body) => {
    const productIndex = body.findIndex((item) => item.type === 'embeddedProduct');
    const hasHeaderAboveProduct = body[productIndex - 1]?.element === 'h2';
    const slicePoint = hasHeaderAboveProduct ? productIndex - 1 : productIndex;

    return [
      ...body.slice(0, slicePoint),
      {
        type: TYPE,
        article,
        vertical,
        presentation: { size: 'edgetoedge' },
      },
      ...body.slice(slicePoint),
    ];
  };
}
